import { TooltipProvider } from '@ctct/payflow-ui';

import { OverdueSummaryWidgetContent } from './OverdueSummaryWidgetContent';
import './overdue-summary-widget.scss';
import type { OverdueSummaryWidgetProps } from './useOverdueSummaryWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const OverdueSummaryWidget = ({ status, handlers, data }: OverdueSummaryWidgetProps) => {
  return (
    <TooltipProvider>
      <div className="overdue-summary-widget">
        <WithStatusHandling
          skeletonHeight={1}
          status={status}
          errorMessage={status === 'error' ? data.message : undefined}
          retry={status === 'error' ? handlers.retry : undefined}
        >
          {status === 'loaded' && <OverdueSummaryWidgetContent data={data} />}
        </WithStatusHandling>
      </div>
    </TooltipProvider>
  );
};
